module.exports = __webpack_public_path__ + "img/file.85a01e7e.svg";